export default {
  init() {
    // JavaScript to be fired on the Affiliate Dashboard - URL Generator page
  },
  finalize() {

    $(document).on('click', '#affiliate-custom-url-copy', function() {
      console.log('clicked');
      /* Get the text field */
      var copyText = $('#affiliate-unique-custom-url');

      console.log(copyText.length);

      /* Select the text field */
      copyText.select();
      copyText[0].setSelectionRange(0, 99999); /*For mobile devices*/

      /* Copy the text inside the text field */
      document.execCommand('copy');

      /* Alert the copied text */
      // alert('Copied the text: ' + copyText.value);
      console.log('finished');
    });

    $(document).on('click', '#product-custom-url-copy', function() {
      /* Get the text field */
      var copyText = $('#affwp-referral-url');

      /* Select the text field */
      copyText.select();
      copyText[0].setSelectionRange(0, 99999); /*For mobile devices*/

      /* Copy the text inside the text field */
      document.execCommand('copy');

      /* Alert the copied text */
      // alert('Copied the text: ' + copyText.value);

    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/affiliatedashboard.js